import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'
import uniq from 'lodash.uniq'

export default class extends Controller {
  static targets = ['facilityTable', 'activeScroll', 'facilityItem']

  initialize () {
    if (this.facilityItemTargets.length > 4) {
      this.activeScrollTarget.style.display = 'block'
      this.facilityTableTarget.addEventListener('scroll', this.handleScroll.bind(this))
    }
  }

  classNames () {
    return JSON.parse(this.element.dataset.classnames)
  }

  className () {
    return this.element.dataset.classname
  }

  facilityName () {
    return this.element.dataset.facilityname
  }

  controllerForAdding () {
    return this.element.dataset.controllerforadding
  }

  controllerForUpdating () {
    return this.element.dataset.controllerforupdating
  }

  remove (e) {
    const clickedButton = e.target
    const targetFacility = this.facilityItemTargets.find(target => target.contains(clickedButton))

    const result = window.confirm(`${targetFacility.dataset.facilityname}を気になるリストから削除しますか？`)
    if (result) {
      this.removeId()
      window.location.reload()
    }
  }

  facilityIds () {
    return JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
  }

  removeId () {
    const id = Number(this.element.dataset.facilityid)
    const ids = this.facilityIds()
    ids.splice(ids.indexOf(id), 1)
    Cookies.set('check_nursing_facility_ids', JSON.stringify(uniq(ids)))
  }

  handleScroll () {
    this.activeScrollTarget.style.display = 'none'
  }
}
